import { render, staticRenderFns } from "./urls.vue?vue&type=template&id=37838124"
import script from "./urls.vue?vue&type=script&lang=js"
export * from "./urls.vue?vue&type=script&lang=js"
import style0 from "./urls.vue?vue&type=style&index=0&id=37838124&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports